import type { FunctionComponent } from "react";
import { NewFavoritesModalAdminPartial } from "../../../../partials/admin/menus/favourites/favourites-modal.admin.partials";

export const NewFavoriteSliderMenuAdminScreen: FunctionComponent = () => {
    return <NewFavoritesModalAdminPartial />;
};
